import type { SVGProps } from 'react';
const SvgSwapVerticalCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#swap_vertical_circle_svg__a)">
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2ZM6.5 9 10 5.5 13.5 9H11v4H9V9H6.5Zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5Z"
      />
    </g>
    <defs>
      <clipPath id="swap_vertical_circle_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSwapVerticalCircle;
